import { render } from "./ProvinceForm.vue?vue&type=template&id=774db1ff&scoped=true&ts=true"
import script from "./ProvinceForm.ts?vue&type=script&lang=ts"
export * from "./ProvinceForm.ts?vue&type=script&lang=ts"

import "./ProvinceForm.scss?vue&type=style&index=0&id=774db1ff&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774db1ff"]])

export default __exports__